export const WHATSAPP_PHONE = "5491123214014";

export const normalizeWhatsAppPhone = (phone = WHATSAPP_PHONE) => {
  const normalized = String(phone || "").replace(/\D/g, "");
  return normalized || WHATSAPP_PHONE;
};

export const WHATSAPP_MESSAGES = Object.freeze({
  GENERAL: "Hola, tengo preguntas sobre mi solicitud de préstamo personal en MicroCuotas.",
  PREAPROBADA:
    "Hola, mi solicitud de préstamo personal fue preaprobada y quiero continuar con el proceso.",
});

export const buildWhatsAppUrl = (
  message = WHATSAPP_MESSAGES.GENERAL,
  phone = WHATSAPP_PHONE
) => `https://wa.me/${normalizeWhatsAppPhone(phone)}?text=${encodeURIComponent(message)}`;
